import { AbstractPerformanceRequirementNote } from './abstract-performance-requirement-note.model';

export class RolloverPerformanceRequirementNote extends AbstractPerformanceRequirementNote {
	completed: number;
	required: number;
}
